import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { MonthlyIncomeReportItem } from '../shared/models/monthly-income-report-item';
import { PoInvoiceDiscrepancyReportData } from '../shared/models/po-discrepancy-report-data';
import { ApiUrlProvider } from './api-url.provider';
import { PpsUtilityService } from './pps-utility.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(
    private http: HttpClient,
    private util: PpsUtilityService,
    private apiUrlProvider: ApiUrlProvider) { }

    generatePoInvoiceDiscrepancyReport(whenDone){
      let url = `${this.apiUrlProvider.url}/report/PoInvoiceDiscrepancyReport`;
  
      this.http
        .get(url, {responseType: 'blob'})
        .subscribe(res => {
          let objectUrl = window.URL.createObjectURL(res);
          let imageAnchor: HTMLAnchorElement = document.createElement("a");
          imageAnchor.href = objectUrl;
          imageAnchor.target = "_blank";
          imageAnchor.download = `project-po-invoice-discrepancy-report.xlsx`;
          imageAnchor.click();
          window.URL.revokeObjectURL(objectUrl);
        }, _ => {})
        .add(()=>{
          if (whenDone){
            whenDone();
          }
        });
    }    

    generateMonthlyIncomeReport(whenDone){
      let url = `${this.apiUrlProvider.url}/report/MonthlyIncomeReport`;
  
      this.http
        .get(url, {responseType: 'blob'})
        .subscribe(res => {
          let objectUrl = window.URL.createObjectURL(res);
          let imageAnchor: HTMLAnchorElement = document.createElement("a");
          imageAnchor.href = objectUrl;
          imageAnchor.target = "_blank";
          imageAnchor.download = `monthly-income-report.xlsx`;
          imageAnchor.click();
          window.URL.revokeObjectURL(objectUrl);
        }, _ => {})
        .add(()=>{
          if (whenDone){
            whenDone();
          }
        });
    }

    getMonthlyIncomeReportData(): Observable<IApiResult<MonthlyIncomeReportItem[]>>{
      return this.http.get<IApiResult<MonthlyIncomeReportItem[]>>(`${this.apiUrlProvider.url}/Report/MonthlyIncomeReportData`);
    }
  
    getPoDiscrepancyReportData(): Observable<IApiResult<PoInvoiceDiscrepancyReportData>>{
      return this.http.get<IApiResult<PoInvoiceDiscrepancyReportData>>(`${this.apiUrlProvider.url}/Report/PoInvoiceDiscrepancyReportData`);
    }
}
